<template>
  <v-layout>
    <v-flex>

      <v-row align="center" no-gutters class="">
        <v-col class="text-left ml-n6 mt-n4">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          {{ forUpdate ? 'Update' : 'Add New' }} User
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="text--primary mt-6">
          <AlertMessage :alerMessage="alerMessage"></AlertMessage>

          <ValidationObserver ref="observer" v-slot="{ validate, reset }">
            <form
              v-on:submit.prevent>
              <v-row class="pa-0">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.code"
                    maxlength="100"
                    label="Code"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="First Name" rules="required|max:100">
                    <v-text-field
                      v-model="user.first_name"
                      maxlength="100"
                      :error-messages="errors"
                      label="First Name"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required|max:100">
                    <v-text-field
                      v-model="user.last_name"
                      maxlength="100"
                      :error-messages="errors"
                      label="Last Name"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Email Address" rules="required|max:100|email">
                    <v-text-field
                      v-model="user.email"
                      maxlength="100"
                      :error-messages="errors"
                      label="Email Address"
                      hint="* Required (e.g. juan.delacruz@email.com)"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.contact_no"
                    maxlength="100"
                    label="Contact No."
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Role" rules="required">
                    <v-select
                      v-model="user.role"
                      :items="roles"
                      menu-props="auto"
                      :error-messages="errors"
                      label="Role"
                      item-text="name"
                      item-value="id"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <v-textarea
                    v-model="user.address"
                    label="Address"
                    auto-grow
                    rows="1"
                    maxlength="255"
                    value="">
                  </v-textarea>
                </v-col>
                <v-col cols="12" md="4">
                  <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                    <v-select
                      v-model="user.status"
                      :items="statuses"
                      menu-props="auto"
                      :error-messages="errors"
                      label="Status"
                      item-text="name"
                      item-value="id"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="user.encrypted_password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    name="password"
                    label="Password"
                    autocomplete="false"
                    hint="At least 6 characters"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn class="d-none" @click="reset"></v-btn>
            </form>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary mr-4"
            depressed
            large
            @click="submit">
            <span class="mx-4">
              {{ loading ? 'Please wait...' : '' }}
              {{ !loading ? forUpdate ? 'Update User' : 'Add User' : '' }}
            </span>
          </v-btn>
          <v-btn
            v-if="!loading"
            depressed
            large
            @click="clear">
            <span class="mx-4">
              Reset Form
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import AlertMessage from '@/components/AlertMessage.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  extend('email', {
    ...email,
    message: '{_field_} must be a valid email',
  })

  export default {
    name: 'user',
    data: () => ({
      adminNamespace: 'admin',
      id: null,
      show1: false,
      loading: false,
      subNavs: [
        {
          text: 'Users',
          disabled: false,
          exact: true,
          to: {
            name: 'users'
          },
        },
        {
          text: 'Add New User',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      roles: [],
      statuses: [],
      user: {
        code: '',
        email: '',
        first_name: '',
        last_name: '',
        contact_no: '',
        role: '',
        address: '',
        encrypted_password: '',
        status: '1'
      }
    }),
    computed: {
      forUpdate: function(){
        return this.id ? true : false
      }
    },
    methods: {
      getDefaultData () {
        let self = this
        this.$http.plain.get(this.adminNamespace+'/default-data?roles=true&user_statuses=true')
          .then(response => {
            this.roles = response.data.roles
            this.statuses = response.data.user_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      getUser () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/users/'+this.id)
          .then(response => {
            this.user = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        },
      addNew () {
        let self = this

        this.$http.secured.post(this.adminNamespace+'/users', this.user)
          .then(response => {
            this.$router.push({ name: 'users', query: { added: true, message: "User has been successfully added" } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      update () {
        let self = this

        delete this.user['id']

        if(Object.prototype.hasOwnProperty.call(this.user, "encrypted_password")){
          if(this.user.encrypted_password.length == 0){
            delete this.user['encrypted_password']
          }
        }

        this.$http.secured.put(this.adminNamespace+'/users/'+this.id, this.user)
          .then(response => {
            this.alerMessage.show = false
            this.showMessage("User has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      async submit () {

        const isValid = await this.$refs.observer.validate();
        if (!isValid) {
          return false;
        }

        if(this.loading){
          return false;
        }

        this.loading = true

        if(this.forUpdate){
          this.update()
        }else{
          this.addNew()
        }
      },
      clear () {
        Object.keys(this.user).forEach(key => {
          this.user[key] = ''
        })

        this.$refs.observer.reset()

        if(this.forUpdate){
          this.getUser()
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      if(this.$route.params.id != 'add'){
        this.subNavs[1].text = 'Update User'
        this.id = this.$route.params.id
        this.getUser()
      }

      this.getDefaultData()
    },
    components: {
      ValidationProvider,
      ValidationObserver,
      SnackBar,
      AlertMessage
    }
  }
</script>
